<template>
    <div class="user_wrap">
        <van-nav-bar
                safe-area-inset-top
                fixed
                :title="$t('lang.我的')"
        >
            <template #right>
                <div class="nav-icon" @click="$router.push('/safe')"><img src="@/assets/img/setting.png" alt=""></div>
                <div class="nav-icon ml-10" @click="$router.push('/notice')"><img src="@/assets/img/msg.png" alt=""></div>
            </template>
        </van-nav-bar>

        <div class="user-head">
            <div class="avatar">
                <img src="@/assets/img/3c1464b1588c3cae.gif" alt="">
            </div>
            <div class="info">
                <div>
                    <span v-if="!hidenPhone">{{ data.mobile }} </span>
                    <span v-else> *********** </span>
                    <span v-if="!hidenPhone" @click="hidenPhone = true ">
                        <van-icon size="20" name="eye-o"/>
                    </span>
                    <span v-else @click="hidenPhone = false ">
                        <van-icon size="20" name="closed-eye"/>
                    </span>
                    <span style="font-size: .5rem">{{ data.vip_name }}</span>
                </div>
                <div>{{ $t('lang.推广码') }}: {{ data.invitation_code }}</div>
            </div>
            <div class="grade" @click="$router.push('/vipDetail')">{{ $t('lang.等级权益') }}</div>
        </div>

        <div class="box">
            <div class="title">
                <div class="left">{{ $t('lang.钱包总资产') }}(USDT) <span class="icon">
                    <img @click="showTips(1)" src="@/assets/img/wt.png" alt=""></span></div>
                <div class="right" @click="signBtn">
                    <span class="icon-sign"><img src="@/assets/img/sigin.png" alt=""></span>
                    <span class="sign">{{ $t('index.sign') }}</span>
                </div>
                <span class="icon"><img @click="showTips(2)" src="@/assets/img/wt.png" alt=""></span>
            </div>
            <div class="num-box">
                <div class="num">
                    <span v-if="!hidenMoeny"> {{ data.all_money }}</span>
                    <span v-else> **** </span>
                    <van-icon size="20" name="eye-o" v-if="!hidenMoeny" @click="hidenMoeny=true"/>
                    <van-icon size="20" name="closed-eye" v-else @click="hidenMoeny=false"/>
                </div>
                <div class="bottom">
                    <div>{{ $t('lang.总投资') }}：{{ data.allInvest }}</div>
                    <div class="line"></div>
                    <div>{{ $t('lang.总收益') }}：{{ data.allIncome }}</div>
                </div>
	            <div class="bottom">
		            <div>{{ $t('lh.今日收益') }}：{{ data.today }}</div>
		            <div class="line"></div>
		            <div>{{ $t('lh.昨日收益') }}：{{ data.yesterday }}</div>
	            </div>
            </div>
            <div class="lines"></div>
            <div class="listBox">
                <div class="item">
                    <div class="title1">{{ $t('lang.原始资产') }}(USDT) <span class="icon"><img @click="showTips(3)" src="@/assets/img/wt.png" alt=""></span></div>
                    <div class="price" v-if="!hidenMoeny">{{ data.money }}</div>
                    <div class="price" v-else>****</div>
                    <div class="transfer" @click="show1 = true">{{ $t('lang.资产划转') }}</div>
                </div>
                <div class="item">
                    <div class="title1">{{ $t('lang.现货资产') }}(USDT) <span class="icon"><img @click="showTips(4)" src="@/assets/img/wt.png" alt=""></span></div>
                    <div class="price" v-if="!hidenMoeny">{{ data.xhMoney }}</div>
                    <div class="price" v-else>****</div>
                    <div class="transfer" @click="show = true">{{ $t('lang.资产划转') }}</div>
                </div>
            </div>
            <div class="lines"></div>
            <div class="listBox">
                <div class="item">
<!--                    <div class="title1">{{ $t('lang.量化资产') }}(USDT) <span class="icon"><img @click="showTips(5)" src="@/assets/img/wt.png" alt=""></span></div>-->
<!--                    <div class="price" v-if="!hidenMoeny">{{ data.lhMoney }}</div>-->
<!--                    <div class="price" v-else>****</div>-->
                    <div class="recharge" @click="$router.push('/invest')">{{ $t('user.recharge') }}</div>
                </div>
                <div class="item">
<!--                    <div class="title1">{{ $t('lang.锁定资产') }}(USDT) <span class="icon"><img @click="showTips(6)" src="@/assets/img/wt.png" alt=""></span></div>-->
<!--                    <div class="price" v-if="!hidenMoeny">{{ data.lockMoney }}</div>-->
<!--                    <div class="price" v-else>****</div>-->
                    <div class="withdrawals" @click="$router.push('/cash')">{{ $t('user.withdraw') }}</div>
                </div>
	            <div class="item">
		            <!--                    <div class="title1">{{ $t('lang.锁定资产') }}(USDT) <span class="icon"><img @click="showTips(6)" src="@/assets/img/wt.png" alt=""></span></div>-->
		            <!--                    <div class="price" v-if="!hidenMoeny">{{ data.lockMoney }}</div>-->
		            <!--                    <div class="price" v-else>****</div>-->
		            <div class="withdrawals" @click="show2 = true">{{ $t('lh.互转') }}</div>
	            </div>
            </div>
        </div>

        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item @click="$router.push('/invite')">
                <img src="@/assets/img/swiper1.png" alt="">
            </van-swipe-item>
            <van-swipe-item @click="$router.push('/vipDetail')">
                <img src="@/assets/img/swiper2.png" alt="">
            </van-swipe-item>
            <van-swipe-item @click="$router.push('/vipDetail')">
                <img src="@/assets/img/swiper3.png" alt="">
            </van-swipe-item>
        </van-swipe>

        <div class="ItemBox">
            <div class="Item" @click="$router.push('/myTeam')">
                <div class="title">{{ $t('lang.我的团队') }}</div>
                <div class="icon">
                    <img src="@/assets/img/myTeam.png" alt="">
                </div>
            </div>
            <div class="Item" @click="toRealName">
                <div class="title">{{ $t('lang.实名认证') }}</div>
                <div class="icon"><img src="@/assets/img/sm.png" alt=""></div>
            </div>
            <div class="Item" @click="$router.push('/order')">
                <div class="title">{{ $t('lang.量化记录') }}</div>
                <div class="icon"><img src="@/assets/img/lhjl.png" alt=""></div>
            </div>
            <!--            withdrawRecord  rechargeRecord-->
            <div class="Item" @click="$router.push('/history')">
                <div class="title">{{ $t('lang.充提记录') }}</div>
                <div class="icon"><img src="@/assets/img/ctjl.png" alt=""></div>
            </div>
        </div>

        <div class="newItemBox">
            <div class="top">{{ $t('lang.常用功能') }}</div>
            <div class="bottom">
                <!--                <div class="newItem" @click="$router.push('/account')">-->
                <!--                    <div class="icon"><img src="@/assets/img/tbdz.png" alt=""></div>-->
                <!--                    <div class="title">{{ $t('lang.提币地址') }}</div>-->
                <!--                </div>-->
                <div class="newItem" @click="$router.push('/invite')">
                    <div class="icon"><img src="@/assets/img/yqhy.png" alt=""></div>
                    <div class="title">{{ $t('user.inviteFriends') }}</div>
                </div>
                <div class="newItem" @click="$router.push('/moneybag')">
                    <div class="icon"><img src="@/assets/img/zjls.png" alt=""></div>
                    <div class="title">{{ $t('lang.资金流水') }}</div>
                </div>
                <div class="newItem" @click="$router.push('/news')">
                    <div class="icon"><img src="@/assets/img/xxtz.png" alt=""></div>
                    <div class="title">{{ $t('lang.资讯') }}</div>
                </div>
	            <div class="newItem" @click="$router.push('/reserve')">
		            <div class="icon"><img src="@/assets/img/xxtz.png" alt=""></div>
		            <div class="title">{{ $t('lh.备用金') }}</div>
	            </div>
            </div>
        </div>

        <cuDialog
                v-model="show"
                @close="show = !show"
                :title="$t('lang.现货资产划转')"
                :confim-text="$t('lang.确认')"
                @confirm="confirm"
        >
            <div class="form-item">
                <span>{{ $t('lang.现货资产') }}</span>
                <span> : ${{ data.xhMoney }}</span>
            </div>
            <div class="form-item">
                <van-field v-model="number" type="number" :placeholder="$t('lang.请输入要划转的金额2')">
                    <template #button>
                        <div @click="number = data.xhMoney">{{ $t('lang.全部') }}</div>
                    </template>
                </van-field>
            </div>
        </cuDialog>
        <cuDialog
                v-model="show1"
                @close="show1 = !show1"
                :title="$t('lang.现货资产划转')"
                :confim-text="$t('lang.确认')"
                @confirm="confirm1"
        >
            <div class="form-item">
                <span>{{ $t('lang.原始资产') }}</span>
                <span> : ${{ data.money }}</span>
            </div>
            <div class="form-item">
                <van-field v-model="number2" type="number" :placeholder="$t('lang.请输入要划转的金额1')">
                    <template #button>
                        <div @click="number2 = data.money">{{ $t('lang.全部') }}</div>
                    </template>
                </van-field>
            </div>
        </cuDialog>
	    
	    <cuDialog
		    v-model="show2"
		    @close="show2 = !show2"
		    :title="$t('lh.互转')"
		    :confim-text="$t('lang.确认')"
		    @confirm="confirm2"
	    >
		    <div class="form-item">
			    <span>{{ $t('lang.原始资产') }}</span>
			    <span> : ${{ data.money }}</span>
		    </div>
		    <div class="form-item">
			    <van-field v-model="userPhone" type="number" :placeholder="$t('lh.请输入会员账户')">
			    </van-field>
		    </div>
		    <div class="form-item">
			    <van-field v-model="number3" type="number" :placeholder="$t('lh.请输入要互转的金额')">
				    <template #button>
					    <div @click="number3 = data.money">{{ $t('lang.全部') }}</div>
				    </template>
			    </van-field>
		    </div>
	    </cuDialog>

        <cuDialog
                v-model="isTips"
                @close="isTips = !isTips"
                :title="$t('lang.提示')"
        >
           <div class="" v-for="item in curMap" :key="item.title">
               <div class="title11">{{ item.title }}</div>
               <div class="sub-title" v-for="sub in item.sub">{{ sub }}</div>
           </div>
            <div class="dia-btn" @click="isTips = false">{{ $t('lang.知道了') }}</div>
        </cuDialog>

        <van-overlay :show="overlayShow" @click="overlayShow = false">
            <div class="cu-over" @click.stop>
                <div class="content">
                    <div class="top">
                        <div class="head">
                            <div>Angle</div>
                            <div class="aa">
                                <div><img src="@/assets/img/icon_notice.png" alt=""></div>
                                <div @click="closeOver">
                                    <van-icon name="close"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bottom">
                        <div class="logo"><img :src="messageInfo.img" alt=""></div>
                        <div class="text">{{ $t('lang.查看具体内容请点击查看详情') }}</div>
                        <van-button
                                class="btn"
                                block
                                color="linear-gradient(0deg, rgb(173, 134, 103) 0%, rgb(244, 228, 215) 100%)"
                                @click="toDetail"
                        >
                            {{ $t('lang.查看详情') }}
                        </van-button>
                    </div>
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import qs from 'qs';
import Fetch from '../../utils/fetch';
import Api from "../../interface/index";
import cuDialog from '@/components/Dialog/index.vue';


export default {
    name: "user",
    components: {cuDialog},
    data() {
        return {
            lang: this.$i18n.locale || 'en_us',
            data: {},
            eye: 1,
            show: false,
            show1:false,
	        show2:false,
            overlayShow: false,
            number: "",
            number2: "",
	        userPhone: '',
	        number3:'',
            messageInfo: {},
            hidenPhone: false,
            hidenMoeny: false,
            isTips: false,
            map:{
                1:[
                    {title: this.$t('lang.什么是钱包总资产'), sub: [this.$t('lang.钱包总资产=原始资产+现货资产+锁定资产')]}
                ],
                2: [
                    {title: this.$t('lang.每日一次，签到即获得原始资产')}
                ],
                3: [
                    {
                        title: this.$t('lang.什么是原始资产(不可提现)?'),
                        sub: [
                            this.$t('lang.您通过充值方式的资金进入到原始资产中(如:数字币充值)'),
                            this.$t('lang.平台奖励的金额(如：注册奖励金额、实名认证成功奖励金额)'),
                        ]
                    },
                    {
                        title: this.$t('lang.原始资产的使用'),
                        sub: [
                            this.$t('lang.购买产品，购买成功将会扣除原始资产的金额')
                        ]
                    }
                ],
                4: [
                    {
                        title: this.$t('lang.什么是现货资产(可提现)?'),
                        sub: [this.$t('lang.量化本金归还、收益、返佣')]
                    },
                    {
                        title: this.$t('lang.现货资产的使用'),
                        sub: [this.$t('lang.现货资产划转到原始资产中'),this.$t('lang.提现数字币'),this.$t('lang.转账给其他会员')]
                    }
                ],
                5: [
                    {title: this.$t('lang.什么是量化资产'), sub: [this.$t('lang.表示正在进行中的量化金额')]}
                ],
                6: [
                    {title: this.$t('lang.什么是锁定资产'),
                        sub: [
                            this.$t('lang.什么是锁定资产'),
                            this.$t('lang.进行中的量化金额'),
                            this.$t('lang.提现待审核的金额'),
                            this.$t('lang.即:锁定的量化金额+锁定的现货资产+锁定的原始资产+待审核的提现 (USDT)')
                        ]
                    }
                ]
            },
            curMap:[]
        };
    },
    activated() {
        this.$parent.footer('user');
        this.start();
    },
    mounted() {
        this.getNews();
    },
    methods: {
        showTips(cur){
            this.curMap = this.map[cur]
            this.isTips = true
        },
        closeOver() {
            this.overlayShow = false;

        },
        getNews() {
            Fetch('/index/getNews', {type: 12}).then(res => {
                let list = res.data.list
                if (!list.length) return;
                if (list[0].show != 1) return;
                this.messageInfo = list[0];
                this.overlayShow = true;
            })
        },
        toDetail() {
            this.$router.push('newsDetail?id=' + this.messageInfo.id)
        },
        toRealName() {
            if (this.data.submitStatus == 1 && this.data.realStatus == 0) {
                this.$router.push('/realNameStatus')
            } else if (this.data.submitStatus == 0 && this.data.realStatus == 0) {
                this.$router.push('/realName')
            } else if (this.data.submitStatus == 1 && this.data.realStatus == 1) {
                this.$router.push('/realNameStatus')
            }
        },
        confirm() {
            if (this.number == '') {
                this.$toast(this.$t('lang.请输入要划转的金额2'));
                return;
            }
            if (this.number == 0) {
                this.$toast(this.$t('lang.暂无现货资金'));
                return;
            }
            Fetch('/user/turnMoney', {money: this.number }).then(res => {
                this.$toast(res.info[this.lang])
                this.show = false
                this.number = ''
                this.start()
            })
        },
        confirm1() {
            if (this.number2 == '') {
                this.$toast(this.$t('lang.请输入要划转的金额1'));
                return;
            }
            if (this.number2 == 0) {
                this.$toast(this.$t('lang.暂无现货资金'));
                return;
            }
            Fetch('/user/turnMoney2', {money: this.number2}).then(res => {
                this.$toast(res.info[this.lang])
                this.show1 = false
                this.number2 = ''
                this.start()
            })
        },
	    
	    confirm2(){
		    if (this.number3 == '') {
			    this.$toast(this.$t('lh.请输入要互转的金额'));
			    return;
		    }
		    if (this.userPhone == '') {
			    this.$toast(this.$t('lh.请输入会员账户'));
			    return;
		    }
		    Fetch('/user/transferUserMoney', {money: this.number3, phone: this.userPhone}).then(res => {
			    this.$toast(res.info[this.lang])
			    this.show2 = false
			    this.number3 = ''
			    this.start()
		    })
	    },
        signBtn() {
            this.$router.push('/sign')
            // Fetch('/user/sign').then(r => {
            //     this.$toast(this.$t('sign.success'))
            // })
        },
        start() {
            Fetch('/user/info').then((r) => {
                this.data = r.data;
            });
        },
        async copy(text) {
            let clipboard = navigator.clipboard || {
                writeText: (text) => {
                    let copyInput = document.createElement('input');
                    copyInput.value = text;
                    document.body.appendChild(copyInput);
                    copyInput.select();
                    document.execCommand('copy');
                    document.body.removeChild(copyInput);
                }
            }
            if (clipboard) {
                await clipboard.writeText(text);
                this.$toast({
                    background: "#07c160",
                    message: this.$t('invest_qrcode.copySucceeded'),
                });
            }
        },
    }
};
</script>

<style lang="less" scoped>
.title11{
  font-size: .78125rem;
  color: #fde5ce;
  padding-top: 1.3125rem;
  margin-left: 1.3125rem;
  margin-bottom: 0.78125rem;
  word-wrap: break-word;
  padding-right: 3.625rem;
}
.sub-title{
  width: 80%;
  margin: 0 auto;
  font-size: .65625rem;
  color: #e1e0e1;
  margin-left: 1.3125rem;
  line-height: 1.25rem;
}
.dia-btn{
  display: inline-block;
  width: 8.375rem;
  height: 2.34375rem;
  background: linear-gradient(0deg,#AC886A 0%,#EFDFD1 100%);
  border-radius: 0.40625rem;
  font-size: .78125rem;
  color: #1d140e;
  text-align: center;
  line-height: 2.34375rem;
  margin-top: 1.21875rem;
  margin-left: 50%;
  transform: translateX(-50%);
}
.cu-over {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .content {
    width: 88%;
    height: 400px;
    position: relative;

    .top {
      position: absolute;
      top: 0;
      width: 100%;
      height: 180px;
      background: linear-gradient(0deg, #FFFFFF 0%, #030000 0%, #B28564 0%, #F8E6D6 100%);
      border-radius: 12px;
      overflow: hidden;
      display: flex;
      align-items: start;

      .head {
        height: 50px;
        padding: 0 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #221c1d !important;
        width: 100%;

        .aa {
          display: flex;
          align-items: center;
        }
      }

      img {
        width: 50px;
        height: auto;
        margin-right: 15px;
      }
    }

    .bottom {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 50px;
      width: 98%;
      height: 300px;
      background: #251E1F;
      border: 0.03125rem solid #513424;
      border-radius: 0.96875rem;
      padding: 10px;

      .logo {
        height: 130px;
        width: 100%;
      }

      .text {
        padding: 0.3125rem;
        text-align: left;
        color: #ececeb;
        font-size: .875rem;
        font-weight: 400;
      }

      .btn {
        width: 50%;
        margin: 50px auto 0 auto;
        border-radius: 8px;
      }
    }
  }
}

.form-item {
  display: flex;
  align-items: center;
  //justify-content: space-between;
  font-size: 16px;
  padding: 12px 2px;
  margin: 4px 0;
}

/deep/ .van-nav-bar {
  color: rgb(239, 216, 196);
  background-color: rgb(35, 29, 29);
}

/deep/ .van-nav-bar__title {
  color: rgb(239, 216, 196);
}

/deep/ .van-nav-bar .van-icon {
  color: rgb(239, 216, 196);
}

img {
  width: 100%;
  height: 100%;
}

.nav-icon {
  width: 20px;
  height: 20px;
}

.ml-10 {
  margin-left: 10px;
}

.flex {
  display: flex;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.user_wrap {
  max-width: 100%;
  height: calc(100vh - 60px);
  overflow-y: scroll;
  overflow-x: hidden;
  padding-bottom: 30px;
  background: url('../../assets/img/home-bg.jpg') repeat center;
  background-size: 100%;
  color: #e8d9d3;
}

.user-head {
  margin-top: 62px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding-left: 20px;

  .avatar {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    overflow: hidden;
    animation: rotation 3s linear infinite;
  }

  @keyframes rotation {

    from {
      -webkit-transform: rotate(0deg);
    }

    to {
      -webkit-transform: rotate(360deg);
    }

  }

  .info {
    flex: 1;
    font-size: 16px;
    margin-left: 15px;

    div {
      margin-bottom: 6px;
    }
  }

  .grade {
    width: 105px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 18px 0 0 18px;
    background: #231D1D;
    font-size: .75rem;
  }
}

.box {
  width: 90%;
  background: #231D1D;
  border: 1px solid #AD8667;
  border-radius: 12px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 18px;
  padding-bottom: 18px;

  .lines {
    width: 90%;
    height: 0.03125rem;
    background: #7D7777;
    margin: 0 auto;
    margin-top: 1rem;
  }

  .icon {
    display: inline-block;
    width: 17px;
    height: 17px;
    margin-left: 6px;
  }

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 20px;
    font-size: .78125rem;

    .left {
      width: 60%;
      height: 42px;
      background: #302A2A;
      border-radius: 12px 0 36px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .right {
      margin-top: 8px;
      width: 90px;
      height: 34px;
      background: linear-gradient(0deg, #A9815F 0%, #FFF0E2 100%);
      border-radius: 9px;
      margin-left: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #482d1c;
      //margin-top: ;
      .icon-sign {
        width: 18px;
        height: 18px;
      }

      .sign {
        display: inline-block;
        padding-left: 6px;
      }
    }
  }

  .num-box {
    margin-top: 20px;
    padding: 6px 12px;

    .num {
      font-size: 1.78125rem;
      color: #efd5be;
      line-height: .96875rem;
    }

    .bottom {
      display: flex;
      margin-top: 1.5rem;
      padding-left: 0.01rem;
      font-size: .65625rem;
      color: #d6d0d0;
      justify-content: start;
      align-items: center;

      .line {
        width: 0.0625rem;
        height: 1.09375rem;
        background: #857F7F;
        margin-left: 0.875rem;
        margin-right: 0.8125rem;
      }
    }
  }

  .listBox {
    display: flex;
    justify-content: space-between;
    margin-top: 0.75rem;
    margin-left: 0.8125rem;
    font-size: .78125rem;
    color: #efd5be;
    line-height: 1.03125rem;

    .item {
      width: 50%;

      .title1 {
        display: flex;
        align-items: center;
      }

      .price {
        font-size: 1.34375rem;
        color: #efd5be;
        margin-top: 0.25rem;
      }

      .transfer {
        width: 6.21875rem;
        height: 1.8125rem;
        background: #231D1D;
        border: 0.0625rem solid #FCE9DF;
        border-radius: 0.53125rem;
        margin-top: 0.875rem;
        font-size: .65625rem;
        color: #e8d9d3;
        line-height: .78125rem;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 0.3125rem;
      }

      .recharge {
        width: 90%;
        height: 2.4375rem;
        background: linear-gradient(0deg, #A77F5C 0%, #F6E6D8 100%);
        border-radius: 0.40625rem;
        font-size: .84375rem;
        color: #482d1c;
        line-height: 2.375rem;
        text-align: center;
        margin-top: 1rem;
      }

      .withdrawals {
        width: 90%;
        height: 2.4375rem;
        border: 1px solid #C7C1C1;
        border-radius: 0.40625rem;
        font-size: .84375rem;
        color: #89807b;
        line-height: 2.375rem;
        text-align: center;
        margin-top: 1rem;
      }
    }
  }

}

.my-swipe {
  width: 90%;
  margin: 0 auto;
  margin-top: 20px;

  .van-swipe-item {
    height: 150px;
  }
}

.ItemBox {
  margin: 0 auto;
  margin-top: 0.34375rem;
  width: 90%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .Item {
    margin-top: 0.65625rem;
    width: 48%;
    height: 3.65625rem;
    background: #231D1D;
    border: 0.03125rem solid #DFC5B3;
    border-radius: 0.53125rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      font-size: .90625rem;
      color: #ead8c4;
      margin-left: 1rem;
    }

    .icon {
      width: 2.0625rem;
      margin-right: 1rem;
    }
  }
}

.newItemBox {
  margin: 0 auto;
  margin-top: 1rem;
  width: 90%;
  background: #231D1D;
  border: 0.0625rem solid #DFC5B3;
  border-radius: 0.53125rem;
  margin-bottom: 1.5625rem;
  padding-bottom: 0.625rem;

  .top {
    width: 100%;
    height: 2.15625rem;
    background: #302A2A;
    border-radius: 0.53125rem 0.53125rem 0 0;
    line-height: 2.15625rem;
    font-size: .8125rem;
    color: #ead8c4;
    padding-left: 1rem;
  }

  .bottom {
    margin-top: 0.9375rem;
    display: flex;
    justify-content: space-evenly;

    .newItem {
      text-align: center;
      flex: 1;

      .icon {
        width: 2.34375rem;
        height: 2.34375rem;
        margin: 0 auto;
      }

      .title {
        margin-top: 0.5625rem;
        font-size: .78125rem;
        color: #ead8c4;
      }
    }
  }
}
</style>
